import React from "react";
import useModal from "./useModal";

interface ModalsProps {
	modalsList: object;
	renderDefault?: string;
}

export function Modals({ modalsList, renderDefault }: ModalsProps) {
	const { openedModalsExist, openedModals } = useModal();

	const renderModal = (name: string) => {
		if (!name || !modalsList[name]) {
			return null;
		}

		return modalsList[name];
	};

	return openedModalsExist
		? openedModals.map((name: string) => (
				<React.Fragment key={name}>{renderModal(name)}</React.Fragment>
			))
		: renderModal(renderDefault);
}
